import React, { useState } from 'react'
import { connect } from 'react-redux'
import { getTintControlData,seTintControlData, setCurrentWindowTintPage, setCurrentZoneStep, setSelectedTintLevel, setSelectedWindows, setWindowTint } from '../../../../../action/roomControlAction'
import { closeOrderPopUp } from '../../../../action/hCommerce2';
import { setLoader } from '../../../../action/homeAction';
import view_logo from '../assets/view_sw_logo.png'

function getCurrentTime(){
  
    let currentTime = new Date();
    return `${currentTime.getDategetFullYear()}-${currentTime.getMonth()+1}-${currentTime.getDate()} ${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}`
  }

function getDoubleDigit(num){
    if(num <= 9){
        return `0${num}`
    }
    return num
}

function WindowZonesStep3(props) {
    const [selectedHour, setSelectedHour] = useState("01")
    const [selectedMinute, setSelectedMinute] = useState("00")
    let count = 0;

    const callSetTintAPI = () => {
        // let startDate = getCurrentTime()
        // let endDate = 

        if(selectedHour == "00" && selectedMinute < 30){
            props.closeOrderPopUp(true, "Please select a valid duration not less than 30 minutes", "",true);
            return
        }

        var todaysDate = new Date();
        var todayFullYearStr = todaysDate.getFullYear();
        var todayMonthStr = getDoubleDigit(todaysDate.getMonth() + 1);
        var todayDayStr = todaysDate.getDate();
    
        var fullDateToday =
            todayFullYearStr + "-" + todayMonthStr + "-" + todayDayStr;
    
        var currentHour = getDoubleDigit(todaysDate.getHours());
        var currentMinute = getDoubleDigit(todaysDate.getMinutes());
    
        //total Minutes till countDown
        count = 0
        var totalMinute = parseInt(selectedHour) * 60 + parseInt(selectedMinute);
        //date object till countdown
        var endDate = new Date(todaysDate.getTime() + totalMinute * 60000);
    
        var fullYearStr = endDate.getFullYear();
        var fullMonthStr = getDoubleDigit(endDate.getMonth() + 1);
        var fullDayStr = endDate.getDate();
    
        var fullDateEnd = fullYearStr + "-" + fullMonthStr + "-" + fullDayStr;
    
        var endHour = getDoubleDigit(endDate.getHours());
        var endMinute = getDoubleDigit(endDate.getMinutes());

        props.setLoader(true, "Sending request...")
    
        props.selectedWindows.forEach((identifier) => {
            props.setWindowTint(props.guestDetail,
                                "setTintState",
                                identifier,
                                props.selectedTintLevel,
                                `${fullDateToday} ${currentHour}:${currentMinute}:00`,
                                `${fullDateEnd} ${endHour}:${endMinute}:00`,
                                (status) => {
                                    count++ 
                                    console.log("props.selectedWindows.length == count", status, props.selectedWindows.length, count);

                                    let tintData = {...props.tintControlData}
                                    let tintZone = tintData.zone
                                    if(status){
                                        tintZone.forEach((iterator) => {
                                            if(iterator.tintCode == identifier){
                                            iterator.previousState = iterator.currentState;
                                            iterator.currentState = props.selectedTintLevel;
                                            iterator.overrideLength = +(selectedHour*60) + +selectedMinute;
                                            iterator.overrideSetAt = fullDateToday + "T" + currentHour + ":" + currentMinute + ":" + "00Z";
                                            iterator.overrideTimeLeft = +(selectedHour*60) + +selectedMinute - 1;
                                            }
                                        })
                                    }

                                    if(props.selectedWindows.length == count){
                                        if(!status){
                                            props.closeOrderPopUp(true, "Something went wrong. Please Contact Hotel admin. OR Try again after some time", "",true);
                                            return
                                        }
                                        props.closeOrderPopUp(true, `Tint Override has been set for the next ${selectedHour} hour and ${selectedMinute} minutes`, "",false);
                                        props.setLoader(false, "")
                                        props.setCurrentWindowTintPage("")
                                        props.setSelectedWindows([])
                                        props.setSelectedTintLevel(1)
                                        props.seTintControlData(tintData)
                                        props.setCurrentZoneStep(1)
                                        // props.getTintControlData(props.guestDetail, (stat) => {
                                        //     if(stat){
                                        //     }
                                        //   })
                                    }
                                })
        })
    }

    return (
        <>
            <header class="inner-pages subpages w-footer">
                <a onClick={props.goBack} class="button-back"></a>
                <div class="heading align-center">
                    <p class="bold">Override</p>
                </div>
            </header>
            <section id="customizeRoom" class="widgets padding-bottom-2 margin-0">
                <div class="widgets">
                    <div class="row">
                        <div class="col">
                            <p class="heading">Set Tint Override Duration</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="tile-rows">
                                <div class="timer-container">
                                    <div class="timer-details">
                                        <div class="timer-name">Set Duration (HH:MM)</div>
                                        <div class="timer-schedule">
                                            <select onChange={(e) => setSelectedHour(e.target.value)} value={selectedHour}>
                                                {["00","01","02","03","04","05","06","07","08","09","10","11","12"]
                                                    .map(val => <option key={val} value={val}>{val}</option>)}
                                            </select>
                                            :
                                            <select onChange={(e) => setSelectedMinute(e.target.value)} value={selectedMinute}>
                                            {["00","10","20","30","40","50"].map(val => <option key={val} value={val}>{val}</option>)}
                                            </select>
                                            {/* <select>
                                                <option selected>AM</option>
                                                <option>PM</option>
                                            </select> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <p class="desc align-center">Tint transitions are not immediate and can take up to 30 minutes.</p>
                            <img src={view_logo} class="ctl-logo" />
                        </div>
                    </div>
                </div>
            </section>

            <footer class="button-controls">
                <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                    <button onClick={callSetTintAPI} class="primary w-100 all-caps">Start Now</button>
                </section>
            </footer>
        </>
    )
}

const mapStateToProps = state => {
    return {
    guestDetail: state.store.home.guestDetails,
    selectedWindows: state.store.selectedWindows,
    selectedTintLevel: state.store.selectedTintLevel,
    tintControlData: state.store.TintControlData,
    }
}

export default connect(mapStateToProps, {
    setWindowTint,
    setLoader,
    setCurrentWindowTintPage,
    setSelectedTintLevel,
    setSelectedWindows,
    setCurrentZoneStep,
    closeOrderPopUp,
    getTintControlData,
    seTintControlData
})(WindowZonesStep3)